import {
    apiRequest,
    riwayatsumpahCreate,
    masterRegion
} from "../../../../../services/adapters/kepegawaian/riwayatsumpahService"

class CreateRepository {

    fetchRegionCountry = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", riwayatsumpahCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository